import React from "react";

// Guides des espaces partenaires : deck de l'équipe (pikachu) et guide PDF envoyé aux partenaires à l'invitation.
export const TEAM_GUIDE_URL = "https://claude.ai/artifact/DJ1j1KhFnqootUEEtH9cPq";
export const PARTNER_GUIDE_URL = "https://partenaires.therunningcollective.fr/guide-partenaires-fr.pdf";

export function GuideLinks() {
    return (
        <p className="small mb-3">
            <a href={TEAM_GUIDE_URL} target="_blank" rel="noopener noreferrer">Guide de l’équipe (slides)</a>
            <span className="text-muted mx-2">·</span>
            <a href={PARTNER_GUIDE_URL} target="_blank" rel="noopener noreferrer">Guide envoyé aux partenaires (PDF)</a>
        </p>
    );
}
